import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { DetailTicket } from "../../../types/models/ticket.model.type";
import type { OpenModalTicketDetailPayload, SharedTicketsState } from "../../../types/states/ticket.state.type";

const initialState: SharedTicketsState = {
  isFetching: false,
  error: undefined,
  modalDetail: {
    isOpen: false,
    dataRecord: undefined,
    action: undefined,
    title: undefined,
  },
  modalCancel: {
    isOpen: false,
    dataRecord: undefined,
  },
  modalRejectAp: {
    isOpen: false,
    dataRecord: undefined,
  },
  modalRejectAt: {
    isOpen: false,
    dataRecord: undefined,
  },
  modalReassign: {
    isOpen: false,
    dataRecord: undefined,
  },
  modalSolve: {
    isOpen: false,
    dataRecord: undefined,
  },
};

const sharedTicketsSlice = createSlice({
  name: "sharedTickets",
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.isFetching = true;
    },
    rxOpenModalTicketDetail: (state, { payload }: PayloadAction<OpenModalTicketDetailPayload | undefined>) => {
      if (payload === undefined) {
        state.modalDetail = {
          ...state.modalDetail,
          isOpen: true,
        };
      } else {
        state.modalDetail = {
          isOpen: true,
          ...payload,
        };
      }
    },
    rxCloseModalTicketDetail: (state) => {
      state.modalDetail = {
        ...state.modalDetail,
        isOpen: false,
      };
    },
    rxOpenModalTicketCancel: (state, { payload }: PayloadAction<DetailTicket | undefined>) => {
      state.modalCancel = {
        isOpen: true,
        dataRecord: payload,
      };
    },
    rxCloseModalTicketCancel: (state) => {
      state.modalCancel = {
        ...state.modalCancel,
        isOpen: false,
      };
    },
    rxOpenModalTicketRejectAt: (state, { payload }: PayloadAction<DetailTicket | undefined>) => {
      state.modalRejectAt = {
        isOpen: true,
        dataRecord: payload,
      };
    },
    rxCloseModalTicketRejectAt: (state) => {
      state.modalRejectAt = {
        ...state.modalRejectAp,
        isOpen: false,
      };
    },
    rxOpenModalTicketRejectAp: (state, { payload }: PayloadAction<DetailTicket | undefined>) => {
      state.modalRejectAp = {
        isOpen: true,
        dataRecord: payload,
      };
    },
    rxCloseModalTicketRejectAp: (state) => {
      state.modalRejectAp = {
        ...state.modalRejectAp,
        isOpen: false,
      };
    },
    rxOpenModalTicketReassign: (state, { payload }: PayloadAction<DetailTicket | undefined>) => {
      state.modalReassign = {
        isOpen: true,
        dataRecord: payload,
      };
    },
    rxCloseModalTicketReassign: (state) => {
      state.modalReassign = {
        ...state.modalReassign,
        isOpen: false,
      };
    },
    rxOpenModalTicketSolve: (state, { payload }: PayloadAction<DetailTicket | undefined>) => {
      state.modalSolve = {
        isOpen: true,
        dataRecord: payload,
      };
    },
    rxCloseModalTicketSolve: (state) => {
      state.modalSolve = {
        ...state.modalSolve,
        isOpen: false,
      };
    },
  },
});

export const {
  rxOpenModalTicketDetail,
  rxCloseModalTicketDetail,
  rxStartFetching,
  rxOpenModalTicketCancel,
  rxCloseModalTicketCancel,
  rxOpenModalTicketRejectAt,
  rxCloseModalTicketRejectAt,
  rxOpenModalTicketRejectAp,
  rxCloseModalTicketRejectAp,
  rxOpenModalTicketReassign,
  rxCloseModalTicketReassign,
  rxOpenModalTicketSolve,
  rxCloseModalTicketSolve,
} = sharedTicketsSlice.actions;
export const sharedTicketsSelector = (state: { sharedTickets: SharedTicketsState }) => state.sharedTickets;
export default sharedTicketsSlice.reducer;
